export default __webpack_public_path__ + "static/media/yellow-ribbon.1bf12149.svg";